import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

interface Product {
    id: number;
    name: string;
}

interface Sale {
    id: number;
    reference_number: string;
}

export default function AddSaleReturnComponent() {
    const [products, setProducts] = useState<Product[]>([]);
    const [sales, setSales] = useState<Sale[]>([]);
    const [product_id, setProductId] = useState<number>(0);
    const [sale_id, setSaleId] = useState<number | null>(null);
    const [quantity, setQuantity] = useState<number>(1);
    const [reason, setReason] = useState<string>('');
    const [totalRefund, setTotalRefund] = useState<string>('0');
    const [returnApproved, setReturnApproved] = useState<boolean>(true);
    const [redirect, setRedirect] = useState<boolean>(false);

    const fetchProducts = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/products/');
            setProducts(response.data.results);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchSales = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/sales/');
            setSales(response.data.results);
        } catch (error) {
            console.error('Error fetching sales:', error);
        }
    };

    useEffect(() => {
        fetchProducts();
        fetchSales();
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const saleReturnData = {
            sale: sale_id,
            product: product_id,
            quantity,
            reason,
            total_refund: totalRefund,
            return_approved: returnApproved,
        };

        try {
            await axios.post('https://api.sominnovations.xyz/Branches/sales-returns/', saleReturnData);
            alert('Sale return added successfully!');
            setRedirect(true);
        } catch (error: any) {
            if (error.response) {
                console.log("Error response data:", error.response.data);
            } else {
                console.error("Error", error.message);
            }
        }
    };

    if (redirect) {
        return <Navigate to="/sales-return" />;
    }

    return (
        <div className="container mt-1" style={{ maxWidth: "800px", padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
            <h2 className="text-center mb-4">Add Sale Return</h2>
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formSale">
                            <Form.Label>Sale</Form.Label>
                            <Form.Control as="select" onChange={(e) => setSaleId(Number(e.target.value))} required>
                                <option value="">Select Sale</option>
                                {sales.map(sale => (
                                    <option key={sale.id} value={sale.id}>
                                        {sale.reference_number}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formProduct">
                            <Form.Label>Product</Form.Label>
                            <Form.Control as="select" onChange={(e) => setProductId(Number(e.target.value))} required>
                                <option value="">Select Product</option>
                                {products.map(product => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formQuantity">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" value={quantity} onChange={(e) => setQuantity(Number(e.target.value))} min="1" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formTotalRefund">
                            <Form.Label>Total Refund</Form.Label>
                            <Form.Control type="text" value={totalRefund} onChange={(e) => setTotalRefund(e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group controlId="formReason" className="mb-3">
                    <Form.Label>Reason</Form.Label>
                    <Form.Control type="text" value={reason} onChange={(e) => setReason(e.target.value)} required />
                </Form.Group>

                <Form.Group controlId="formReturnApproved" className="mb-4">
                    <Form.Check 
                        type="checkbox" 
                        label="Return Approved" 
                        checked={returnApproved} 
                        onChange={(e) => setReturnApproved(e.target.checked)} 
                    />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                    Add Sale Return
                </Button>
            </Form>
        </div>
    );
}
